import backgroundImage from '@assets/agents/background-create-templates.png';
import { Box, Typography, Button } from '@mui/material';

import { ConfigureButton } from '@/components/Agents/AgentCard/AgentCardStyles';

interface ActivateTemplateCardProps {
  onActivate: () => void;
}

const ActivateTemplateCard = ({ onActivate }: ActivateTemplateCardProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderRadius: '16px',
      backgroundImage: `url(${backgroundImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      padding: '16px',
      width: '100%',
      height: '72px',
      boxShadow: 2
    }}
  >
    <Typography color="black" sx={{ fontWeight: 'bold', maxWidth: '60%', fontSize: '13px' }}>
      Create your own templates!
      <Typography color="gray" sx={{ maxWidth: '60%', fontSize: '11px' }}>
        Take control of your meetings – customize your summaries!
      </Typography>
    </Typography>

    <ConfigureButton
      onClick={e => {
        e.stopPropagation();
        onActivate();
      }}
      sx={{ minWidth: '140px', fontWeight: 'bold', padding: '8px 12px' }}
    >
      Activate
    </ConfigureButton>
  </Box>
);

export default ActivateTemplateCard;
